import { RSAA } from 'redux-api-middleware';
import {
  GET_USER_REQUESTED,
  GET_USER_SUCCESS,
  GET_USER_FAILURE,
  GET_USER_POLL,
  PATCH_USER_REQUESTED,
  PATCH_USER_SUCCESS,
  PATCH_USER_FAILURE,
  DELETE_USER_REQUESTED,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAILURE,
  CREATE_USERINVITE_REQUESTED,
  CREATE_USERINVITE_SUCCESS,
  CREATE_USERINVITE_FAILURE,
  GET_USERINVITE_REQUESTED,
  GET_USERINVITE_SUCCESS,
  GET_USERINVITE_FAILURE,
  DELETE_USERINVITE_REQUESTED,
  DELETE_USERINVITE_SUCCESS,
  DELETE_USERINVITE_FAILURE,
} from '../actions';

const getUsersPollActionSet = () => ({
  [RSAA]: {
    types: [GET_USER_POLL, GET_USER_SUCCESS, GET_USER_FAILURE],
    method: 'GET',
    endpoint: '/users/',
  },
});

export const getUsersPoll = () => (dispatch) => dispatch(getUsersPollActionSet());

const getUsersActionSet = () => ({
  [RSAA]: {
    types: [GET_USER_REQUESTED, GET_USER_SUCCESS, GET_USER_FAILURE],
    method: 'GET',
    endpoint: '/users/',
  },
});

export const getUsersState = () => (dispatch) => dispatch(getUsersActionSet());

const updateUsersActionSet = (data, userId, orgORv4ID) => ({
  [RSAA]: {
    types: [
      PATCH_USER_REQUESTED,
      {
        type: PATCH_USER_SUCCESS,
        meta: { userId, orgORv4ID },
      },
      PATCH_USER_FAILURE,
    ],
    method: 'PATCH',
    endpoint: `/users/${userId}/`,
    body: JSON.stringify(data),
  },
});

export const updateUsersState = (details, userId, orgORv4ID) => (dispatch) =>
  dispatch(updateUsersActionSet(details, userId, orgORv4ID));

const deleteUserActionSet = (id) => ({
  [RSAA]: {
    types: [
      DELETE_USER_REQUESTED,
      {
        type: DELETE_USER_SUCCESS,
        meta: { userId: id },
      },
      DELETE_USER_FAILURE,
    ],
    method: 'DELETE',
    endpoint: `/users/${id}/`,
  },
});

export const deleteUser = (id) => (dispatch) => dispatch(deleteUserActionSet(id));

const createUserInviteActionSet = (data) => ({
  [RSAA]: {
    types: [
      CREATE_USERINVITE_REQUESTED,
      {
        type: CREATE_USERINVITE_SUCCESS,
        meta: {
          analytics: true,
        },
      },
      CREATE_USERINVITE_FAILURE,
    ],
    method: 'POST',
    endpoint: '/userinvites/',
    body: JSON.stringify(data),
  },
});

export const createUserInvite = (details) => (dispatch) =>
  dispatch(createUserInviteActionSet(details));

const getUserInviteActionSet = () => ({
  [RSAA]: {
    types: [GET_USERINVITE_REQUESTED, GET_USERINVITE_SUCCESS, GET_USERINVITE_FAILURE],
    method: 'GET',
    endpoint: '/userinvites/',
  },
});

export const getUserInvitesState = () => (dispatch) => dispatch(getUserInviteActionSet());

const deleteUserInviteActionSet = (id) => ({
  [RSAA]: {
    types: [
      DELETE_USERINVITE_REQUESTED,
      {
        type: DELETE_USERINVITE_SUCCESS,
        meta: { inviteId: id },
      },
      DELETE_USERINVITE_FAILURE,
    ],
    method: 'DELETE',
    endpoint: `/userinvites/${id}/`,
  },
});

export const deleteUserInviteState = (id) => (dispatch) => dispatch(deleteUserInviteActionSet(id));

export const resendUserInviteState = (id, data) => (dispatch) =>
  dispatch(deleteUserInviteActionSet(id)).then(() => dispatch(createUserInvite(data)));
